export class SimpleListModel {
    idx: number = 0;
    s: string = '';
}